import {mixpanel} from "../util/mixpanel";
let fps;
const times = [];
let start;
let rafId;

const urlParams = new URLSearchParams(window.location.search);

export function tick_fps(timestamp) {
    if (start === undefined)
        start = timestamp;
    const elapsed = timestamp - start;

    // check fps rate
    const now = performance.now();
    while (times.length > 0 && times[0] <= now - 3000) {
        times.shift();
    }
    times.push(now);
    if (elapsed > 1000) {
        fps = Math.round(times.length / 3);
        if (urlParams.get('debug')) {
            document.getElementById('fps-monitor').innerText = fps + " FPS";
        }
        start = timestamp;
    }
    rafId = requestAnimationFrame(tick_fps);
}

setTimeout(() => {
    mixpanel.track('FPS', {
            "browser_lang": window.navigator.language,
            "fps": fps
        });
    // stop counting frames if not in debug mode
    if (!urlParams.get('debug')) {
        cancelAnimationFrame(rafId);
    }
}, 30000); // 30 seconds delay

